<div class="form-group">
  @if (showLabel && getLabel()) {
    <label class="form-group__label">{{ getLabel() }}</label>
  }

  @for (item of items; track item.answer) {
    <label class="tile" [class.tile--reveal]="isReveal(item)">
      <input
        [type]="getInputType(item)"
        [name]="uniqueControlName"
        [value]="item?.answer"
        [checked]="isSelected(item)"
        [disabled]="isDisabled(item)"
        (change)="onChange(item, $event)">
      <div class="tile__inner">
        <div class="tile__main">
          @if (item?.leftIcon) {
            <div class="tile__left">
              <svg class="icon icon--md">
                <use [attr.xlink:href]="'#' + getIconName(item.leftIcon)"></use>
              </svg>
            </div>
          }

          <div class="tile__content">
            @if (item?.showIndicator) {
              <div class="tile__indi"><span></span></div>
            }
            @if (hasValue(item?.count)) {
              <div class="tile__count">
                <span class="tag-pill tag-pill--num-outline">{{ item.count }}</span>
              </div>
            }
            <div class="tile__label">
              @if (item?.title) {
                <div class="tile__title">{{ item.title }}</div>
              }
              @if (item?.subtitle) {
                <div class="tile__subtitle">{{ item.subtitle }}</div>
              }
            </div>
            @if (hasBadge(item)) {
              <div class="tile__meta">
                <span class="tag-pill" [class]="'tag-pill ' + getBadgeClass(item)">{{ getBadgeText(item) }}</span>
              </div>
            }
          </div>

          @if (hasRightContent(item)) {
            <div class="tile__right">
              @if (item?.showPopover || item?.tooltip || item?.tooltipContent) {
                <a class="popover-trigger popover-trigger--sm" tabindex="0" data-toggle="popover"
                  data-trigger="focus" data-html="true" data-placement="bottom"
                  [attr.data-content]="getTooltipContent(item)">
                  <svg class="icon icon--sm">
                    <use xlink:href="#help-Icon"></use>
                  </svg>
                </a>
              }
              @for (icon of item.icons; track $index) {
                <svg [class]="getIconClass(icon, item)">
                  <use [attr.xlink:href]="'#' + getIconName(icon)"></use>
                </svg>
              }
              @if (item?.imageUrl) {
                <img [src]="item.imageUrl" [class]="item?.imageClass || 'icon icon--lg-xl'" alt="">
              }
              @if (item?.switch) {
                <div class="tile__switch"></div>
              }
              @if (hasValue(item?.price)) {
                <p class="price">
                  <strong>{{ getPriceValue(item) }}</strong>
                  @if (getPriceFrequency(item)) {
                    /{{ getPriceFrequency(item) }}
                  }
                </p>
              }
            </div>
          }
        </div>

        @if ((showItk && getItkItems(item).length) || isReveal(item)) {
          <div class="tile__slot">
            @if (isReveal(item)) {
              <div class="tile__slot-reveal">
                @if (getRevealContent(item)) {
                  <div [innerHTML]="getRevealContent(item)"></div>
                } @else {
                  <app-question-textbox
                    [question]="item.revealQuestion"
                    [readOnly]="isDisabled(item)"
                    [showLabel]="false"
                    [placeHolderText]="item?.revealPlaceholder || 'Placeholder'"
                    [value]="item?.revealValue || ''"
                    (questionAnswer)="onRevealAnswer(item, $event)">
                  </app-question-textbox>
                }
              </div>
            }

            @if (showItk && getItkItems(item).length) {
              <app-itk [items]="getItkContent(item)"></app-itk>
            }
          </div>
        }
      </div>
    </label>
  }
</div>
